module.exports = "/static/assets/c31c20a96bdc6ffe5916c9fb25d1e505.svg";